module.exports = __webpack_public_path__ + "img/2_149.18380ba8.png";